/**
 * Marketing Colors Configuration
 * Semantic color palette for marketing analytics modules
 * Supports light and dark themes
 */

export const MARKETING_COLORS = {
  // Pixels / Tracking
  pixels: {
    light: {
      bg: '#f0f4ff',
      border: '#cbd5e0',
      text: '#2d3748',
      accent: '#5b21b6',
    },
    dark: {
      bg: '#312e81',
      border: '#5b21b6',
      text: '#e0e7ff',
      accent: '#a78bfa',
    },
  },

  // Loyalty / Fidelity
  loyalty: {
    light: {
      bg: '#fef3c7',
      border: '#fcd34d',
      text: '#78350f',
      accent: '#d97706',
    },
    dark: {
      bg: '#78350f',
      border: '#d97706',
      text: '#fef3c7',
      accent: '#fcd34d',
    },
  },

  // Cashbacks
  cashback: {
    light: {
      bg: '#dbeafe',
      border: '#93c5fd',
      text: '#0c4a6e',
      accent: '#0284c7',
    },
    dark: {
      bg: '#082f49',
      border: '#0284c7',
      text: '#dbeafe',
      accent: '#38bdf8',
    },
  },

  // Push Notifications
  push: {
    light: {
      bg: '#ede9fe',
      border: '#c4b5fd',
      text: '#4c1d95',
      accent: '#7c3aed',
    },
    dark: {
      bg: '#4c1d95',
      border: '#7c3aed',
      text: '#ede9fe',
      accent: '#c4b5fd',
    },
  },

  // Evaluations / Reviews
  evaluations: {
    light: {
      bg: '#fecaca',
      border: '#fca5a5',
      text: '#7f1d1d',
      accent: '#dc2626',
    },
    dark: {
      bg: '#7f1d1d',
      border: '#dc2626',
      text: '#fecaca',
      accent: '#fca5a5',
    },
  },

  // Coupons
  coupons: {
    light: {
      bg: '#ecfdf5',
      border: '#86efac',
      text: '#166534',
      accent: '#16a34a',
    },
    dark: {
      bg: '#166534',
      border: '#16a34a',
      text: '#ecfdf5',
      accent: '#86efac',
    },
  },

  // Promotions
  promotions: {
    light: {
      bg: '#fee2e2',
      border: '#fca5a5',
      text: '#991b1b',
      accent: '#ef4444',
    },
    dark: {
      bg: '#7f1d1d',
      border: '#ef4444',
      text: '#fee2e2',
      accent: '#f87171',
    },
  },

  // Chatbot
  chatbot: {
    light: {
      bg: '#e0f2fe',
      border: '#7dd3fc',
      text: '#0c4a6e',
      accent: '#0ea5e9',
    },
    dark: {
      bg: '#082f49',
      border: '#0ea5e9',
      text: '#e0f2fe',
      accent: '#7dd3fc',
    },
  },

  // Bulk Sending (Envios)
  envios: {
    light: {
      bg: '#f3e8ff',
      border: '#d8b4fe',
      text: '#5b21b6',
      accent: '#a855f7',
    },
    dark: {
      bg: '#5b21b6',
      border: '#a855f7',
      text: '#f3e8ff',
      accent: '#d8b4fe',
    },
  },

  // Links / URL Tracking
  links: {
    light: {
      bg: '#fef08a',
      border: '#fde047',
      text: '#78350f',
      accent: '#eab308',
    },
    dark: {
      bg: '#713f12',
      border: '#eab308',
      text: '#fef08a',
      accent: '#facc15',
    },
  },

  // Video Generation
  video: {
    light: {
      bg: '#fce7f3',
      border: '#fbbbf9',
      text: '#831843',
      accent: '#ec4899',
    },
    dark: {
      bg: '#831843',
      border: '#ec4899',
      text: '#fce7f3',
      accent: '#f472b6',
    },
  },

  // WhatsApp Analytics
  whatsapp: {
    light: {
      bg: '#d1fae5',
      border: '#6ee7b7',
      text: '#064e3b',
      accent: '#10b981',
    },
    dark: {
      bg: '#064e3b',
      border: '#10b981',
      text: '#d1fae5',
      accent: '#6ee7b7',
    },
  },
};

// Helper function to get colors for a module
export const getMarketingColors = (module, isDark = false) => {
  const colors = MARKETING_COLORS[module];
  if (!colors) {
    console.warn(`[marketingColors] Module not found: ${module}`);
    return MARKETING_COLORS.loyalty[isDark ? 'dark' : 'light'];
  }
  return colors[isDark ? 'dark' : 'light'];
};

// Helper to get color by theme preference
export const getModuleColor = (module, colorKey, theme = 'light') => {
  const colors = MARKETING_COLORS[module];
  if (!colors || !colors[theme] || !colors[theme][colorKey]) {
    return '#000000'; // Fallback
  }
  return colors[theme][colorKey];
};
